import React, { useState, useEffect } from "react";
import { Grid2, useMediaQuery } from "@mui/material"; // Import media query hook
import BackgroundImage from "/Images/Background.svg";
import Bapepti from "/Images/Mask group.svg";
import Kominfo from "/Images/Mask group (1).svg";
import Custody from "/Images/custody.svg";
import Lottie from "react-lottie";
import "../Components/HeroTransition.css"; // Import CSS file
import animationData from "./CUSTODY (1).json";

const assets = [
  { text: "digital assets", color: "#F4E37B" },
  { text: "blockchain investments", color: "#A1D6E2" },
  { text: "tokenized assets", color: "#FF6B6B" },
];

const HeroSection = () => {
  const [currentAssetIndex, setCurrentAssetIndex] = useState(0);
  const [animationKey, setAnimationKey] = useState(0); // State for animation
  const isMobile = useMediaQuery("(max-width: 767px)"); // Media query check

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentAssetIndex((prevIndex) => (prevIndex + 1) % assets.length);
      setAnimationKey((prevKey) => prevKey + 1); // Trigger animation
    }, 2000);

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const styles = {
    button: {
      backgroundColor: "#F4E37B",
      color: "#214D73",
      padding: isMobile ? "10px 20px" : "15px 30px",
      borderRadius: "8px",
      border: "none",
      fontSize: isMobile ? "0.875rem" : "1rem",
      cursor: "pointer",
      textDecoration: "none",
      display: "inline-block",
    },
  };

  return (
    <section
      style={{
        backgroundImage: `url(${BackgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        padding: isMobile ? "0 2.5rem" : "0 6rem",
        paddingTop: isMobile ? "6rem" : "12rem",
        paddingBottom: isMobile ? "6rem" : "12rem",
        minHeight: isMobile ? "450px" : "820px",

        color: "#FFFFFF",
      }}
    >
      <Grid2 container spacing={2} alignItems="flex-start">
        <Grid2 size={6} md={6} paddingLeft={{ md: 0, lg: 0 }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "30px",
            }}
          >
            <img src={Custody} alt="Custody Icon"
              style={{
                height: isMobile ? "30px" : "40px",
                marginRight: "10px",
              }}
            />
            <h2>
              Custody
            </h2>
          </div>
          <h1
            style={{
              fontSize: isMobile ? "24px" : "50px",
              fontWeight: 550,
              lineHeight: "1.2",
            }}
          >
            <span> Advanced Solutions for </span> <br />
            <span style={{ color: "#F4E37B" }}>Right at Your Fingertips</span>
          </h1>
          <p
            style={{
              fontSize: isMobile ? "14px" : "22px",
              color: "#E7E4E2",
            }}
          >
            We provide optimized tools for wallet engineers to <br />
            safeguard and protect digital assets whenever needed.
          </p>
          <a href="#contact" style={styles.button}>
            Find out more
          </a>
        </Grid2>
        <Grid2 size={6} md={6}>
          {isMobile ? (
            <div
              style={{
                zIndex: 1,
              }}
            >
              <Lottie options={defaultOptions} width="350px" height="250px" />
            </div>
          ) : (
            <div
              style={{
                overflow: "hidden",
              }}
            >
              <Lottie options={defaultOptions} width="750px" height="400px" />
            </div>
          )}
        </Grid2>
      </Grid2>
    </section >
  );
};

export default HeroSection;
